export default __webpack_public_path__ + "static/4-ff35202747c16b9a3a87cec2d61d4c67.jpeg";